var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, Button, LayoutControls, Radio } from '@pinwheel/origami';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useOpts } from '../../../context';
import TitleFrame from '../../../LinkApiRouter/components/TitleFrame';
import PartialSwitchToggle from './PartialSwitchToggle';
import FullSwitchAndMoreProvider from './context';
import useFullSwitchAndMoreContext from './hooks/useFullSwitchAndMoreContext';
import useOnEnterHandler from '../../../LinkApiRouter/hooks/useOnEnterHandler';
import useOrgName from '../../../hooks/useOrgName';
import useSkipDepositConfirmation from '../../../LinkApiRouter/hooks/useSkipDepositConfirmation';
import useAmountSelectionButtonText from '../../../LinkApiRouter/hooks/useAmountSelectionButtonText';
import { useGetLocalizedString } from '../../../hooks/useGetLocalizedString';
import usePercentageSupported from './hooks/usePercentageSupported';
import AmountRadioButton from './AmountRadioButton';
import PercentageRadioButton from './PercentageRadioButton';
import RemainderRadioButton from './RemainderRadioButton';
import useAmountSupported from './hooks/useAmountSupported';
import { selectFeatureFlags } from '../../../state/slices/slice-link-params';
function FullSwitchAndMoreInner(_a) {
    var onContinue = _a.onContinue;
    var getLocalizedString = useGetLocalizedString();
    var _b = useOpts(), amountSelection = _b.amountSelection, setAmountSelection = _b.setAmountSelection;
    var featureFlags = useSelector(selectFeatureFlags);
    var orgName = useOrgName();
    var percentageSupported = usePercentageSupported();
    var amountSupported = useAmountSupported();
    var isValid = useFullSwitchAndMoreContext().isValid;
    useOnEnterHandler(isValid, onContinue);
    useSkipDepositConfirmation(onContinue);
    var buttonText = useAmountSelectionButtonText();
    var atLeastTwoSwitchTypesEnabled = useMemo(function () {
        return ((percentageSupported && !(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.disableRemainderSwitch)) ||
            (percentageSupported && amountSupported) ||
            (amountSupported && !(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.disableRemainderSwitch)));
    }, [amountSupported, percentageSupported, featureFlags]);
    return (React.createElement(React.Fragment, null,
        React.createElement(TitleFrame
        /**
         * https://pinwheel.atlassian.net/browse/CORE-1783
         * Display "payout" wording instead of "paycheck" for Square workspace
         */
        , { 
            /**
             * https://pinwheel.atlassian.net/browse/CORE-1783
             * Display "payout" wording instead of "paycheck" for Square workspace
             */
            title: getLocalizedString('DIRECT_DEPOSIT_SETTINGS'), subtitle: getLocalizedString('HOW_MUCH_TO_ORG', [orgName]) },
            React.createElement(Box, null,
                React.createElement(Radio, { eventId: "FullSwitchAndMore-entirePaycheck", "data-testid": "Radio-entirePaycheck", value: "entirePaycheck", checked: (amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action) === 'full_switch', label: getLocalizedString('FULL_PAYCHECK'), onChange: function () { return setAmountSelection === null || setAmountSelection === void 0 ? void 0 : setAmountSelection({ action: 'full_switch' }); } }),
                atLeastTwoSwitchTypesEnabled ? (
                // Only show the partial paycheck toggle if at least two partial switch types are enabled
                React.createElement(Radio, { value: "partialPaycheck", "data-testid": "Radio-partialPaycheck", checked: (amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action) !== 'full_switch', 
                    /**
                     * https://pinwheel.atlassian.net/browse/CORE-1783
                     * Display "payout" wording instead of "paycheck" for Square workspace
                     */
                    label: getLocalizedString('PARTIAL_PAYCHECK'), eventId: "FullSwitchAndMore-partialPaycheck", onChange: function () {
                        if (amountSupported) {
                            setAmountSelection === null || setAmountSelection === void 0 ? void 0 : setAmountSelection({
                                action: 'partial_switch',
                                allocation: {
                                    type: 'amount',
                                    value: null,
                                },
                            });
                        }
                        else {
                            setAmountSelection === null || setAmountSelection === void 0 ? void 0 : setAmountSelection({
                                action: 'partial_switch',
                                allocation: {
                                    type: 'percentage',
                                    value: null,
                                },
                            });
                        }
                    } }, (amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action) === 'full_switch' ? null : (React.createElement(PartialSwitchToggle, null)))) : amountSupported ? (React.createElement(AmountRadioButton, null)) : percentageSupported ? (React.createElement(PercentageRadioButton, null)) : !(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.disableRemainderSwitch) ? (React.createElement(RemainderRadioButton, null)) : // should never hit this case because we'll go straight to confirmation screen if neither amount nor percentage is supported
                    null)),
        React.createElement(LayoutControls, null,
            React.createElement(Button, { eventId: "AmountSelection-continue", "data-testid": "button", disabled: !isValid, onClick: onContinue }, buttonText))));
}
var FullSwitchAndMore = function (props) { return (React.createElement(FullSwitchAndMoreProvider, null,
    React.createElement(FullSwitchAndMoreInner, __assign({}, props)))); };
export default FullSwitchAndMore;
